<template>
  <div>
    <table width="100%" class="lida-leading-table padding">
      <thead>
        <tr>
          <th colspan="4">内容</th>
        </tr>
      </thead>
      <tbody>
        <tr class="row-column">
          <th width="50%" colspan="2">补货设定</th>
          <th width="25%">类型</th>
          <th width="25%">
            自动补货
            <Button type="primary" @click="chagneautoipt(1)" class="ml-1 mr-1">自动</Button>
            <Button type="primary" @click="chagneautoipt(2)" class="ml-1">手动</Button>
          </th>
        </tr>
        <tr v-for="(it, index) in rpmeltge_data" :key="index+'wlsge_data'" class="row-column">
          <th>{{it.buhuoname}}</th>
          <td>
            <Input
              v-model.number="it.found"
              style="width:120px;"
              @on-change="setItems(it, 'found')"
            />
          </td>
          <td class="fontweight">
            <span v-if="it.wareclass == 1" class="blue-text">仓位</span>
            <span v-else-if="it.wareclass == 2">占成</span>
          </td>
          <td>
            <RadioGroup v-model="it.autoinpt" @on-change="setItems(it, 'autoinpt')">
              <Radio :label="1">自动</Radio>
              <Radio :label="2">手动</Radio>
            </RadioGroup>
          </td>
        </tr>
        <tr>
          <td colspan="3"></td>
          <td>
            <Button type="primary" @click="chagneautoipt(1)" class="ml-1 mr-1">自动</Button>
            <Button type="primary" @click="chagneautoipt(2)" class="ml-1">手动</Button>
          </td>
        </tr>
      </tbody>
    </table>
    <Row type="flex" align="middle" justify="center" class="mt-4 mb-2">
      <Button type="error" size="large" class="mt-1 mb-3" @click="modify">储存</Button>
      <i-col span="24">
        <p class="tc">
          說明：自動補倉從你開啟此項功能開始，每一個新單都會幫你進行超額計算，同時限定最小自動下調金額大於等於0。
          <br />例如：某佔成設置為300，如果此時你的佔成小於300系統則不會自動幫你補；必須佔成大於300時，係統才會幫你補掉大於300的那部分。
          <br />本系统於 特码,正特码,半波 这3个玩法中的补货设定是以"仓位"型式进行设定. "仓位"可理解为"扣底", 客户亦可以理解为於此玩法中可承受的最高风险.
          <br />假设客户於特码的补货设定设为十万, 则代表不论开奖结果如何, 客户於特码这玩法中最高只可输十万.对比於以"占成金额"型式进行的设定其优点可令代理商更容易控制风险以及最大化其盈利
          <br />
        </p>
      </i-col>
    </Row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'SettingReplenishment',
  data () {
    return {
      rpmeltge_data: [],
      items: [],
      setradio: "1"
    };
  },
  computed: {
    ...mapGetters(['getmember', 'getgameid'])
  },
  watch: {
    getgameid () {
      this.rpmeltge();
    }
  },
  created () {
    this.rpmeltge();
  },
  methods: {
    async rpmeltge () {
      try {
        const res = await this.$axios.setting.getReplenishmentList(this.getgameid)
        if ('status' in res && res.status === 0) return
        this.rpmeltge_data = res;
      } catch (error) {
        console.error(error);
      }
    },
    setItems (it, key) {
      let flat = true;
      const id = key == 'autoinpt' ? '99' + it.id : it.id
      if (this.items.length) {
        this.items.forEach(res => {
          if (res.id == id) {
            flat = false;
            res.newvalue = it[key];
          }
        });
      }
      if (!this.items || flat) {
        this.items.push({ id: Number(id), newvalue: it[key] });
      }
    },
    chagneautoipt (index) {
      this.rpmeltge_data.forEach(it => {
        it.autoinpt = index
        this.setItems(it, 'autoinpt')
      })
    },
    modify () {
      const obj = {
        loid: this.getmember.pid,
        reppid: '1',
        items: this.items
      }
      this.$axios.setting.modifyReplenishmentList(this.getgameid, obj).then(res => {
        if (res.status == 1) {
          this.$Message.success("修改成功");
          this.items = []
          this.rpmeltge()
        }
      }).catch(error => {
        console.log(error)
        this.$Message.error("栏位异常");
      })
    }
  }
};
</script>
